import { render } from "./PoliticaLogModal.vue?vue&type=template&id=06ac3d5d"
import script from "./PoliticaLogModal.vue?vue&type=script&lang=js"
export * from "./PoliticaLogModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__